import { render } from "./StartUp_res.vue?vue&type=template&id=1a6e604e&scoped=true&ts=true"
import script from "./StartUp_res.vue?vue&type=script&lang=ts"
export * from "./StartUp_res.vue?vue&type=script&lang=ts"

import "./StartUp_res.vue?vue&type=style&index=0&id=1a6e604e&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6e604e"]])

export default __exports__